import React, { useRef,useEffect } from "react";
import { TForgotPasswordStep3Props } from "./ForgotPasswordStep3.types";
import hidePasswordImage from "../../../../assets/images/hide.svg"
import showPasswordImage from "../../../../assets/images/show.svg"
import ForgetIconImage from "../../../../assets/images/forget-logo.svg"
import pageBackImage from "../../../../assets/images/back.svg"
import { Link,useNavigate,useParams } from "react-router-dom";
import { toast } from 'react-toastify';

import authApi from "../../../../services/authentication";
import useApi from "../../../../services/Base/useApi";

const ForgotPasswordStep3 = (props: TForgotPasswordStep3Props) => {

    const passwordInputRef = useRef() as React.MutableRefObject<HTMLInputElement>;
    const confirmPasswordInputRef = useRef() as React.MutableRefObject<HTMLInputElement>;

    const resetPasswordApi = useApi(authApi.putResetPassword);

    const navigate = useNavigate();

    const { token } = useParams();

    useEffect(()=>{
      if(!resetPasswordApi.error && !resetPasswordApi.loading && resetPasswordApi.data){
        navigate("/forgot-password/forgot-password-step4")
      }else if(resetPasswordApi.error){
        toast.error("Invalid token");
        navigate("/forgot-password/forgot-password-step1")
      }
    },[resetPasswordApi.error,resetPasswordApi.loading,resetPasswordApi.data])

    const submitHandler = () => {

      const enteredPassword = passwordInputRef.current.value;
      const enteredConfirmPassword = confirmPasswordInputRef.current.value;

      if(enteredPassword !== enteredConfirmPassword){
        toast.error("New password and confirm password must be the same." )
      }else if(enteredPassword.length < 8){
        toast.error("Password must be at least 8 characters.")
      }else{
        const data = { "password": enteredPassword, resetToken: token };
        resetPasswordApi.request(data);
      }
    }

    return (
        <div className="authPageWrap">
            <div className="authCreateWrapper">
                <img src={ForgetIconImage} alt="icon" className="authTopLogo"/>
                <h2 className="registrationHead text-center m-b-0 greyTxt">Set new password</h2>
                <h4 className="registrationSubhead width70p">Your new password must be different to previously used password</h4>
                <div className="customColumn500">
                    <div className="customColumn-12  m-b-20 ">
                        <label className="formLabel font-bold">New password</label>
                        <div className="gap10"></div>
                        <div className="passwordDiv">
                            <input type="password" ref={passwordInputRef} className="inputText authInput" placeholder="********"/>

                        </div>
                    </div>
                    <div className="customColumn-12  m-b-20 ">
                        <label  className="formLabel font-bold">Confirm password</label>
                        <div className="gap10"></div>
                        <div className="passwordDiv">
                            <input type="password" ref={confirmPasswordInputRef}className="inputText authInput" placeholder="********"/>
                        </div>
                    </div>
                    <div className="gap20"></div>
                    <div className="customColumn-12 text-center">
                        <div className="customColumn-12  m-b-20 text-center">
                            <button onClick={submitHandler} className="btnCustom btnYellow authButton">Reset password</button>
                            {/* <button className="btnCustom btnYellow authButton">Reset password</button> */}
                        </div>
                    </div>
                    <div className="gap20"></div>
                    <div className="customColumn-12 text-center">
                        <div className="backPageLink text-center">
                            <Link to="/login"><img src={pageBackImage} alt="icon" /> Back to log in</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ForgotPasswordStep3;
